import PropTypes from 'prop-types';
import { fDate } from 'src/utils/formatTime';
import useResponsive from 'src/hooks/useResponsive';
import Iconify from 'src/components/Iconify';
import { CALENDARIO_DESIGN as D } from 'src/pages/dashboard/Calendario/Calendario.design';

// ----------------------------------------------------------------------

const VIEW_OPTIONS = [
  { value: 'dayGridMonth', label: 'Mês', icon: 'ic:round-view-module' },
  { value: 'timeGridWeek', label: 'Semana', icon: 'ic:round-view-week' },
  { value: 'timeGridDay', label: 'Dia', icon: 'ic:round-view-day' },
];

CalendarToolbar.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onToday: PropTypes.func,
  onNextDate: PropTypes.func,
  onPrevDate: PropTypes.func,
  onChangeView: PropTypes.func,
  view: PropTypes.oneOf(['dayGridMonth', 'timeGridWeek', 'timeGridDay', 'listWeek']),
};

export default function CalendarToolbar({
  date,
  view,
  onToday,
  onNextDate,
  onPrevDate,
  onChangeView,
  onOpen,
}) {
  const isDesktop = useResponsive('up', 'sm');

  return (
    <>
      {/* Center: View toggles + Navigation */}
      <div className={D.header.center}>
        {isDesktop && (
          <div className={D.header.viewToggle.container}>
            {VIEW_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                className={`${D.header.viewToggle.button} ${
                  opt.value === view
                    ? D.header.viewToggle.active
                    : D.header.viewToggle.inactive
                }`}
                onClick={() => onChangeView(opt.value)}
              >
                <Iconify icon={opt.icon} width={16} height={16} />
                {opt.label}
              </button>
            ))}
          </div>
        )}

        <div className={D.header.nav.container}>
          <button className={D.header.nav.button} onClick={onPrevDate}>
            <Iconify icon="eva:arrow-ios-back-fill" width={20} height={20} />
          </button>
          <span className={D.header.nav.dateLabel}>{fDate(date)}</span>
          <button className={D.header.nav.button} onClick={onNextDate}>
            <Iconify icon="eva:arrow-ios-forward-fill" width={20} height={20} />
          </button>
        </div>
      </div>

      {/* Right: Create + Today */}
      <div className={D.header.right}>
        <button className={D.header.createButton} onClick={onOpen}>
          <Iconify icon="eva:plus-fill" width={16} height={16} />
          Criar Evento
        </button>
        <button className={D.header.todayButton} onClick={onToday}>
          Hoje
        </button>
      </div>
    </>
  );
}
